// Function to organize the menu items into columns
function organizeMenuItemsIntoColumns() {
  // Select the original list of menu items
  const originalList = document.querySelector('.mega-menu__list');

  // Get all list items as an array
  const listItems = Array.from(originalList.querySelectorAll('li'));

  // Determine the number of items per column
  const itemsPerColumn = 3;

  // Create a new div container to hold all the columns
  const divContainer = document.createElement('div');
  divContainer.className = 'menu-columns-container'; // Optional: Add a class for styling

  // Calculate the number of columns needed
  const numberOfColumns = Math.ceil(listItems.length / itemsPerColumn);

  // Loop through and create columns
  for (let i = 0; i < numberOfColumns; i++) {
    // Create a new <ul> element for each column
    const columnContainer = document.createElement('ul');
    columnContainer.className = originalList.className;

    // Add the appropriate items to each column
    for (let j = i * itemsPerColumn; j < (i + 1) * itemsPerColumn && j < listItems.length; j++) {
      columnContainer.appendChild(listItems[j].cloneNode(true));
    }

    // Append each column container to the new div container
    divContainer.appendChild(columnContainer);
  }

  // Replace the original list with the new div containing all columns
  originalList.parentNode.replaceChild(divContainer, originalList);
}

// Check if the width is above 767 pixels and apply the function
if (window.innerWidth > 767) {
  organizeMenuItemsIntoColumns();
}

// Optional: Add an event listener to handle window resizing
window.addEventListener('resize', function() {
  if (window.innerWidth > 767) {
    organizeMenuItemsIntoColumns();
  }
});
